export const updateToast = (state, status) => {
    state.toast = status;
};

const ToastMutation = {
    updateToast
};

export default ToastMutation;